/**
 * BBE — Collection BOGO Self-Tanner LP (lp-col-bogo-st-01)
 * Alpine.js bundle picker + liquidAjaxCart checkout flow.
 */
(function () {
  'use strict';

  if (window.__lpColBogoStLoaded) return;
  window.__lpColBogoStLoaded = true;

  var LP_AJAX_CART_SILENT_OPTS = { info: { should_keep_drawer_closed: true } };

  var LP_PRE_UPSELL_ADD_SELECTOR =
    '.pre-upsell__item:not(.added):not(.pre-upsell__item--market-hidden):not([hidden]) button[data-upsell-add]:not([disabled])';

  function getCheckoutUrl() {
    var modal = document.querySelector('pre-upsell-modal');
    return (modal && modal.dataset.checkoutUrl) || '/checkout';
  }

  function isPreUpsellEnabled(root) {
    if (!root) return false;
    var flag = root.querySelector('.lp-col-bogo-st-01-pre-upsell-flag[data-enable-pre-upsell="true"]');
    return !!flag;
  }

  function resolvePreUpsellCheckout(modal) {
    if (typeof window.bbeResolvePreUpsellCheckout === 'function') {
      return window.bbeResolvePreUpsellCheckout(modal);
    }
    if (!(modal instanceof Element)) return Promise.resolve({ action: 'skip' });
    return Promise.resolve({
      action: modal.querySelector(LP_PRE_UPSELL_ADD_SELECTOR) ? 'open' : 'skip'
    });
  }

  function skipPreUpsellToCheckout(checkoutUrl) {
    if (typeof window.bbeSkipPreUpsellToCheckout === 'function') {
      window.bbeSkipPreUpsellToCheckout(checkoutUrl);
      return;
    }
    window.location.assign(checkoutUrl || '/checkout');
  }

  function openPreUpsellModal(modal, invoker) {
    if (!modal) return Promise.resolve(false);
    if (typeof modal.open === 'function') {
      modal.open(invoker || null);
      return Promise.resolve(true);
    }
    return customElements.whenDefined('pre-upsell-modal').then(function () {
      if (typeof modal.open === 'function') {
        modal.open(invoker || null);
        return true;
      }
      return false;
    });
  }

  function runPreUpsellAfterCartAdd(root, invoker) {
    var preUpsellModal = document.querySelector('pre-upsell-modal');

    if (!preUpsellModal) {
      window.location.assign(getCheckoutUrl());
      return Promise.resolve();
    }

    return resolvePreUpsellCheckout(preUpsellModal)
      .then(function (outcome) {
        if (outcome && outcome.action === 'open') {
          return openPreUpsellModal(preUpsellModal, invoker).then(function (opened) {
            if (!opened) throw new Error('pre-upsell open failed');
          });
        }
        skipPreUpsellToCheckout(preUpsellModal.dataset.checkoutUrl || getCheckoutUrl());
      })
      .catch(function (err) {
        console.warn('[lp-col-bogo-st-01] pre-upsell failed; routing to checkout', err);
        skipPreUpsellToCheckout(getCheckoutUrl());
      });
  }

  function getConfig(root) {
    if (!root) return {};
    try {
      return JSON.parse(root.getAttribute('data-lp-config') || '{}');
    } catch (e) {
      return {};
    }
  }

  function getProducts(root) {
    if (!root) return [];
    var sectionId = root.getAttribute('data-lp-section-id');
    var el = sectionId
      ? document.getElementById('lp-col-bogo-st-01-products-' + sectionId)
      : null;
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function addItemsWithDiscount(items, discountCode) {
    var discount = (discountCode || '').trim();

    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
      return new Promise(function (resolve, reject) {
        window.liquidAjaxCart.add(
          { items: items },
          Object.assign({}, LP_AJAX_CART_SILENT_OPTS, {
            lastCallback: function (state) {
              if (!state || !state.responseData || state.responseData.ok === false) {
                reject(new Error('cart add failed'));
                return;
              }
              if (!discount || typeof window.liquidAjaxCart.update !== 'function') {
                resolve();
                return;
              }
              window.liquidAjaxCart.update({ discount: discount }, {
                lastCallback: function () { resolve(); }
              });
            }
          })
        );
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function (json) {
        if (json && json.status) throw new Error(json.description || 'cart add failed');
        if (!discount) return;
        return fetch('/discount/' + encodeURIComponent(discount), { credentials: 'same-origin' }).catch(function () {});
      });
  }

  window.lpColBogoStBundle = function () {
    var root = document.querySelector('[data-lp-col-bogo-st-01-root]');
    var config = getConfig(root);
    var products = getProducts(root);
    var initialVariants = {};
    products.forEach(function (p) {
      initialVariants[String(p.id)] = String(p.variantId);
    });

    return {
      showSticky: false,
      claiming: false,
      products: products,
      selectedIds: [],
      variantSelections: initialVariants,
      tab: 'how',

      init: function () {
        var self = this;
        if (window.location.hash === '#how-to-use') {
          this.tab = 'how';
        }
        window.addEventListener('hashchange', function () {
          if (window.location.hash === '#how-to-use') {
            self.tab = 'how';
          }
        });
      },

      get selectedCount() {
        return this.selectedIds.length;
      },

      getProduct: function (id) {
        var key = String(id);
        return this.products.find(function (p) { return String(p.id) === key; });
      },

      getVariantId: function (id) {
        var sel = this.variantSelections[String(id)];
        return sel ? Number(sel) : 0;
      },

      getPrice: function (id) {
        var prod = this.getProduct(id);
        if (!prod) return 0;
        var vid = this.getVariantId(id);
        var variant = (prod.variants || []).find(function (v) { return Number(v.id) === vid; });
        return variant ? variant.price : prod.price;
      },

      setVariant: function (id, variantId) {
        this.variantSelections[String(id)] = String(variantId);
      },

      toggleProduct: function (id) {
        id = String(id);
        var idx = this.selectedIds.indexOf(id);
        if (idx > -1) {
          this.selectedIds.splice(idx, 1);
        } else if (this.selectedIds.length < 2) {
          this.selectedIds.push(id);
        } else {
          this.selectedIds[1] = id;
        }
      },

      isSelected: function (id) {
        return this.selectedIds.indexOf(String(id)) > -1;
      },

      isFree: function (id) {
        return this.selectedIds.indexOf(String(id)) === 1;
      },

      get selectedProducts() {
        var self = this;
        return this.selectedIds.map(function (id) {
          var p = self.getProduct(id);
          if (!p) return null;
          return {
            id: id,
            title: p.title,
            img: p.img,
            price: self.getPrice(id),
            variantId: self.getVariantId(id)
          };
        }).filter(Boolean);
      },

      get totalPrice() {
        if (this.selectedCount === 0) return 0;
        return this.selectedProducts[0].price;
      },

      get comparePrice() {
        if (this.selectedCount === 0) return 0;
        if (this.selectedCount === 1) return this.selectedProducts[0].price;
        return this.selectedProducts[0].price + this.selectedProducts[1].price;
      },

      scrollToShop: function () {
        var shop = document.getElementById('shop');
        if (shop) {
          shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      },

      scrollToAnchor: function (anchorId) {
        var el = document.getElementById(anchorId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (anchorId === 'how-to-use') {
          this.tab = 'how';
          window.location.hash = 'how-to-use';
        }
      },

      stackStyle: function (index) {
        var count = this.selectedCount;
        var rot = count === 1 ? '0deg' : (index === 0 ? '-5deg' : '5deg');
        var tx = count === 1 ? '0px' : (index === 0 ? '-8px' : '8px');
        return 'z-index:' + (index + 1) + ';transform:rotate(' + rot + ') translateX(' + tx + ');';
      },

      claimOffer: function () {
        if (this.claiming || this.selectedCount !== 2) return;

        var items = this.selectedProducts.map(function (p) {
          return { id: Number(p.variantId), quantity: 1 };
        }).filter(function (item) {
          return Number.isFinite(item.id) && item.id > 0;
        });

        if (items.length !== 2) {
          console.warn('[lp-col-bogo-st-01] Missing variant IDs for selected products');
          return;
        }

        this.claiming = true;
        var discountCode = (config.discountCode || 'bogo').trim();
        var self = this;

        addItemsWithDiscount(items, discountCode)
          .then(function () {
            if (isPreUpsellEnabled(root)) {
              return runPreUpsellAfterCartAdd(root, null);
            }
            window.location.assign(getCheckoutUrl());
          })
          .catch(function (err) {
            console.warn('[lp-col-bogo-st-01] Cart add failed; routing to checkout', err);
            window.location.assign(getCheckoutUrl());
          })
          .finally(function () {
            self.claiming = false;
          });
      }
    };
  };
})();
